"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removePx = void 0;
function removePx(valueWithPx) {
    return Number(String(valueWithPx).replace("px", ""));
}
exports.removePx = removePx;
